import { Routes, Route, Navigate } from "react-router-dom";
import { SignedIn, SignedOut, SignIn, SignUp } from "@clerk/clerk-react";
import { PropertyProvider } from "./lib/property-context";
import RootSwitch from "./routes/RootSwitch";
import Dashboard from "./routes/Dashboard";
import Contractors from "./routes/Contractors";
import Tenants from "./routes/Tenants";
import { VersionPill } from "./components/VersionPill";

export default function App() {
  return (
    <>
    <Routes>
      <Route path="/" element={<RootSwitch />} />
      <Route
        path="/sign-in/*"
        element={
          <CenteredAuth>
            <SignIn routing="path" path="/sign-in" signUpUrl="/sign-up" />
          </CenteredAuth>
        }
      />
      <Route
        path="/sign-up/*"
        element={
          <CenteredAuth>
            <SignUp routing="path" path="/sign-up" signInUrl="/sign-in" />
          </CenteredAuth>
        }
      />
      <Route
        path="/:propertySlug/dashboard"
        element={
          <PropertyGate>
            <Dashboard />
          </PropertyGate>
        }
      />
      <Route
        path="/:propertySlug/contractors"
        element={
          <PropertyGate>
            <Contractors />
          </PropertyGate>
        }
      />
      <Route
        path="/:propertySlug/tenants"
        element={
          <PropertyGate>
            <Tenants />
          </PropertyGate>
        }
      />
      <Route path="/:propertySlug" element={<Navigate to="dashboard" replace />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
    <VersionPill />
    </>
  );
}

// Guards a property-scoped route: requires sign-in (signed-out kicks to
// /sign-in) and resolves the URL's :propertySlug param to a property
// via Convex before rendering the inner route.
function PropertyGate({ children }: { children: React.ReactNode }) {
  return (
    <>
      <SignedIn>
        <PropertyProvider>{children}</PropertyProvider>
      </SignedIn>
      <SignedOut>
        <Navigate to="/sign-in" replace />
      </SignedOut>
    </>
  );
}

function CenteredAuth({ children }: { children: React.ReactNode }) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 px-6 py-12">
      {children}
    </div>
  );
}
